/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Owner,
    OwnerFromJSON,
    OwnerFromJSONTyped,
    OwnerToJSON,
} from './';

/**
 * 
 * @export
 * @interface OwnershipTypesResponse
 */
export interface OwnershipTypesResponse {
    /**
     * 
     * @type {string}
     * @memberof OwnershipTypesResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof OwnershipTypesResponse
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof OwnershipTypesResponse
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof OwnershipTypesResponse
     */
    min: number;
    /**
     * 
     * @type {number}
     * @memberof OwnershipTypesResponse
     */
    max: number;
    /**
     * 
     * @type {Array<Owner>}
     * @memberof OwnershipTypesResponse
     */
    ownerTypes: Array<Owner>;
}

export function OwnershipTypesResponseFromJSON(json: any): OwnershipTypesResponse {
    return OwnershipTypesResponseFromJSONTyped(json, false);
}

export function OwnershipTypesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OwnershipTypesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'type': json['type'],
        'description': json['description'],
        'min': json['min'],
        'max': json['max'],
        'ownerTypes': ((json['ownerTypes'] as Array<any>).map(OwnerFromJSON)),
    };
}

export function OwnershipTypesResponseToJSON(value?: OwnershipTypesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'type': value.type,
        'description': value.description,
        'min': value.min,
        'max': value.max,
        'ownerTypes': ((value.ownerTypes as Array<any>).map(OwnerToJSON)),
    };
}


